import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const showSuccessAlert = (message: string = "Saved successfully.") => {
  return MySwal.fire({
    icon: "success",
    title: "Success",
    text: message,
    confirmButtonText: "OK",
  });
};

export const showErrorAlert = (message: string = "Something went wrong.") => {
  return MySwal.fire({
    icon: "error",
    title: "Error",
    text: message,
    confirmButtonText: "OK",
  });
};

export const showInfoAlert = (message: string = "No changes detected.") => {
  return MySwal.fire({
    icon: "info",
    title: "Notice",
    text: message,
    confirmButtonText: "OK",
  });
};

export const showToastSuccess = (message: string) => {
  return MySwal.fire({
    icon: "success",
    title: message,
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
};

export const showUnsavedChangesAlert = () => {
  return MySwal.fire({
    icon: "warning",
    title: "Unsaved Changes",
    text: "You have unsaved changes. Do you want to save them or discard them?",
    showCancelButton: false,
    showDenyButton: true,
    confirmButtonText: "Save Changes",
    denyButtonText: "Discard",
    cancelButtonText: "Cancel",
  });
};

export const showConfirmationAlert = (
  title: string = "Are you sure?",
  message: string = "You won't be able to revert this!",
  preConfirmCallback?: () => Promise<any>,
  customOptions: any = {}
) => {
  const options: any = {
    title: title,
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
    ...customOptions,

    allowOutsideClick: () => !MySwal.isLoading(),
    allowEscapeKey: () => !MySwal.isLoading(),
    allowEnterKey: false,
  };

  if (preConfirmCallback) {
    options.showLoaderOnConfirm = true;
    options.preConfirm = async () => {
      try {
        const result = await preConfirmCallback();
        return result !== undefined ? result : true;
      } catch (error: any) {
        MySwal.showValidationMessage(
          error.response?.data?.message || error.message || "Request failed"
        );
        return false;
      }
    };
  }

  return MySwal.fire(options);
};
